module.exports = __webpack_public_path__ + "static/img/2层.2113f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/2层.png
// module id = LVAG
// module chunks = 0